// extracted by mini-css-extract-plugin
export var container = "_53-0";
export var disabled = "_53-4";
export var fullWidth = "_53-3";
export var lined = "_53-1";
export var selected = "_53-5";
export var tab = "_53-2";